import React from 'react';

import { Sections as SectionsView } from 'apps/system';
import SectionDetail from './Sections/SectionDetail';
import { Apps as AppsView } from 'apps/system';
import AppDetail from './Apps/AppDetail';
import { Items as ItemsView } from 'apps/system';
import ItemDetail from './Items/ItemDetail';
import { Questions as QuestionsView } from 'apps/system';
import QuestionDetail from './Questions/QuestionDetail';
import { Documents as DocumentsView } from 'apps/system';
import DocumentDetail from './Documents/DocumentDetail';
import { Attachments as AttachmentsView } from 'apps/system';
import AttachmentDetail from './Attachments/AttachmentDetail';
import { Products as ProductsView } from 'apps/system';
import ProductDetail from './Products/ProductDetail';
import { Users as UsersView } from 'apps/system';
import UserDetail from './Users/UserDetail';
import { Accounts as AccountsView } from 'apps/system';
import AccountDetail from './Accounts/AccountDetail';
import { Memberships as MembershipsView } from 'apps/system';
import MembershipDetail from './Memberships/MembershipDetail';
import { Subscriptions as SubscriptionsView } from 'apps/system';
import SubscriptionDetail from './Subscriptions/SubscriptionDetail';
import { Payments as PaymentsView } from 'apps/system';
import PaymentDetail from './Payments/PaymentDetail';
import { Groups as GroupsView } from 'apps/system';
import GroupDetail from './Groups/GroupDetail';
import { Messages as MessagesView } from 'apps/system';
import MessageDetail from './Messages/MessageDetail';
import { Invitations as InvitationsView } from 'apps/system';
import InvitationDetail from './Invitations/InvitationDetail';
import { Programmes as ProgrammesView } from 'apps/system';
import ProgrammeDetail from './Programmes/ProgrammeDetail';
import CartView from './Ecommerce/Cart';
import CheckoutView from './Ecommerce/Checkout';
import OrderCompleteView from './Ecommerce/OrderComplete';

const appRoutes = [
  {
    path: '/system/dashboard/sections',
    renderer: (params = {}): JSX.Element => <SectionsView {...params} />,
  },
  {
    path: '/system/dashboard/section/:sectionid',
    renderer: (params = {}): JSX.Element => <SectionDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-section',
    renderer: (params = {}): JSX.Element => <SectionDetail {...params} />,
  },
  {
    path: '/system/dashboard/apps',
    renderer: (params = {}): JSX.Element => <AppsView {...params} />,
  },
  {
    path: '/system/dashboard/app/:appid',
    renderer: (params = {}): JSX.Element => <AppDetail {...params} />,
  },
  {
    path: '/system/dashboard/app/add-app',
    renderer: (params = {}): JSX.Element => <AppDetail {...params} />,
  },
  {
    path: '/system/dashboard/section/:sectionid/items',
    renderer: (params = {}): JSX.Element => <ItemsView {...params} />,
  },
  {
    path: '/system/dashboard/section/:sectionid/item/:itemid',
    renderer: (params = {}): JSX.Element => <ItemDetail {...params} />,
  },
  {
    path: '/system/dashboard/section/:sectionid/item/add-item',
    renderer: (params = {}): JSX.Element => <ItemDetail {...params} />,
  },
  {
    path: '/system/dashboard/questions',
    renderer: (params = {}): JSX.Element => <QuestionsView {...params} />,
  },
  {
    path: '/system/dashboard/question/:questionid',
    renderer: (params = {}): JSX.Element => <QuestionDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-question',
    renderer: (params = {}): JSX.Element => <QuestionDetail {...params} />,
  },
  {
    path: '/system/dashboard/documents',
    renderer: (params = {}): JSX.Element => <DocumentsView {...params} />,
  },
  {
    path: '/system/dashboard/document/:documentid',
    renderer: (params = {}): JSX.Element => <DocumentDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-document',
    renderer: (params = {}): JSX.Element => <DocumentDetail {...params} />,
  },
  {
    path: '/system/dashboard/attachments',
    renderer: (params = {}): JSX.Element => <AttachmentsView {...params} />,
  },
  {
    path: '/system/dashboard/attachment/:attachmentid',
    renderer: (params = {}): JSX.Element => <AttachmentDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-attachment',
    renderer: (params = {}): JSX.Element => <AttachmentDetail {...params} />,
  },
  {
    path: '/system/dashboard/products',
    renderer: (params = {}): JSX.Element => <ProductsView {...params} />,
  },
  {
    path: '/system/dashboard/product/:productid',
    renderer: (params = {}): JSX.Element => <ProductDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-product',
    renderer: (params = {}): JSX.Element => <ProductDetail {...params} />,
  },
  {
    path: '/system/dashboard/users',
    renderer: (params = {}): JSX.Element => <UsersView {...params} />,
  },
  {
    path: '/system/dashboard/user/:userid',
    renderer: (params = {}): JSX.Element => <UserDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-user',
    renderer: (params = {}): JSX.Element => <UserDetail {...params} />,
  },
  {
    path: '/system/dashboard/accounts',
    renderer: (params = {}): JSX.Element => <AccountsView {...params} />,
  },
  {
    path: '/system/dashboard/account/:accountid',
    renderer: (params = {}): JSX.Element => <AccountDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-account',
    renderer: (params = {}): JSX.Element => <AccountDetail {...params} />,
  },
  {
    path: '/system/dashboard/account/:accountid/memberships',
    renderer: (params = {}): JSX.Element => <MembershipsView {...params} />,
  },
  {
    path: '/system/dashboard/account/:accountid/membership/:membershipid',
    renderer: (params = {}): JSX.Element => <MembershipDetail {...params} />,
  },
  {
    path: '/system/dashboard/account/:accountid/add-membership',
    renderer: (params = {}): JSX.Element => <MembershipDetail {...params} />,
  },
  {
    path: '/system/dashboard/membership/:membershipid/payments',
    renderer: (params = {}): JSX.Element => <PaymentsView {...params} />,
  },
  {
    path: '/system/dashboard/membership/:membershipid/payment/:paymentid',
    renderer: (params = {}): JSX.Element => <PaymentDetail {...params} />,
  },
  {
    path: '/system/dashboard/membership/:membershipid/add-payment',
    renderer: (params = {}): JSX.Element => <PaymentDetail {...params} />,
  },
  {
    path: '/system/dashboard/membership/:membershipid/subscriptions',
    renderer: (params = {}): JSX.Element => <SubscriptionsView {...params} />,
  },
  {
    path: '/system/dashboard/membership/:membershipid/subscription/:subscriptionid',
    renderer: (params = {}): JSX.Element => <SubscriptionDetail {...params} />,
  },
  {
    path: '/system/dashboard/membership/:membershipid/add-subscription',
    renderer: (params = {}): JSX.Element => <SubscriptionDetail {...params} />,
  },
  {
    path: '/system/dashboard/subscription/:subscriptionid/payments',
    renderer: (params = {}): JSX.Element => <PaymentsView {...params} />,
  },
  {
    path: '/system/dashboard/subscription/:subscriptionid/payment/:paymentid',
    renderer: (params = {}): JSX.Element => <PaymentDetail {...params} />,
  },
  {
    path: '/system/dashboard/subscription/:subscriptionid/add-payment',
    renderer: (params = {}): JSX.Element => <PaymentDetail {...params} />,
  },
  {
    path: '/system/dashboard/account/:accountid/groups',
    renderer: (params = {}): JSX.Element => <GroupsView {...params} />,
  },
  {
    path: '/system/dashboard/account/:accountid/group/:groupid',
    renderer: (params = {}): JSX.Element => <GroupDetail {...params} />,
  },
  {
    path: '/system/dashboard/account/:accountid/add-group',
    renderer: (params = {}): JSX.Element => <GroupDetail {...params} />,
  },
  {
    path: '/system/dashboard/messages',
    renderer: (params = {}): JSX.Element => <MessagesView {...params} />,
  },
  {
    path: '/system/dashboard/message/:messageid',
    renderer: (params = {}): JSX.Element => <MessageDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-message',
    renderer: (params = {}): JSX.Element => <MessageDetail {...params} />,
  },
  {
    path: '/system/dashboard/invitations',
    renderer: (params = {}): JSX.Element => <InvitationsView {...params} />,
  },
  {
    path: '/system/dashboard/invitation/:invitationid',
    renderer: (params = {}): JSX.Element => <InvitationDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-invitation',
    renderer: (params = {}): JSX.Element => <InvitationDetail {...params} />,
  },
  {
    path: '/system/dashboard/programmes',
    renderer: (params = {}): JSX.Element => <ProgrammesView {...params} />,
  },
  {
    path: '/system/dashboard/programme/:programmeid',
    renderer: (params = {}): JSX.Element => <ProgrammeDetail {...params} />,
  },
  {
    path: '/system/dashboard/add-programme',
    renderer: (params = {}): JSX.Element => <ProgrammeDetail {...params} />,
  },
  {
    path: '/system/dashboard/ecommerce/cart',
    renderer: (params = {}): JSX.Element => <CartView {...params} />,
  },
  {
    path: '/system/dashboard/ecommerce/checkout',
    renderer: (params = {}): JSX.Element => <CheckoutView {...params} />,
  },
  {
    path: '/system/dashboard/ecommerce/order-complete',
    renderer: (params = {}): JSX.Element => <OrderCompleteView {...params} />,
  },
];

export default appRoutes;
